require('@/utils/pace/pace')

// URLs to ignore. ['some-substring', /some-regexp/]
const paceIgnoreUrls = []

window.Pace.start({
  restartOnRequestAfter: true,
  restartOnPushState: false,
  ajax: {
    trackMethods: ['GET', 'POST'],
    ignoreURLs: paceIgnoreUrls,
    trackWebSockets: false,
  }
})